<template>
    <div class="container-general">
        <search-panorama-short-title v-model="generalFilters.shortTitle" />
        <search-panorama-apenafs v-model="generalFilters.apenafCode" :apenafs="apenafs" />
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import SearchPanoramaApenafs from "./SearchPanoramaApenafs.vue";
import SearchPanoramaShortTitle from "./SearchPanoramaShortTitle.vue";

export default {
    props: ["value", "apenafs", "subjects"],
    components: {
        SearchPanoramaApenafs,
        SearchPanoramaShortTitle,
    },
    data() {
        return {
            viewFilters: false,
            generalFilters: {
                apenafCode: this.value.apenafCode,
                shortTitle: this.value.shortTitle,
                csps: this.value.csps,
            },
        };
    },
    mounted() {
        EventBus.$on("clearPanoramaFilters", () => {
            this.generalFilters = {
                apenafCode: null,
                shortTitle: null,
                csps: null,
            };
        });
    },
    watch: {
        generalFilters: {
            handler(_generalFilters) {
                this.$emit("input", _generalFilters);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass">
.container-general
    margin-top: 4px
    margin-bottom: 32px
</style>
